<template>
  <section>
    <!-- SB-02 -->
    <div
      id="sb-02"
      v-if="$store.state.currentLocation >= 2"
    >
      <banner-full-width headerText="Évaluation des risques"></banner-full-width>
      <content-block>
        <!-- 5-01-00 -->
        <!-- <banner-full-width headerText=""></banner-full-width> -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">À venir</h2>
        <p>Dans cette section, nous examinerons l'environnement de pratique de l'aviron et nous évaluerons les risques possibles. </p>
        <p>Lorsque nous connaissons bien notre environnement, nous sommes en mesure de prendre des décisions éclairées pour atténuer les risques.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="3"
          link="sb-03"
        >
          Montrez-moi comment
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-01 -->
    <div
      id="sb-03"
      v-if="$store.state.currentLocation >= 3"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Évaluer les risques</h2>
        <p>L'évaluation des risques et la prise de décisions sont des activités essentielles que nous mettons en application toute notre vie. En tant qu'entraîneurs, administrateurs de clubs, membres de conseils, athlètes ou juges-arbitres, nous devons tous évaluer les risques inhérents à nos activités. C'est notre façon de nous protéger.</p>
        <p>L'évaluation des risques comporte trois étapes.</p>
        <div class="row">
          <div class="col-sm bg-red text-center p-4 m-3">
            <img
              src="@/assets/img/_content/03-1.svg"
              class="img-fluid w-50 mb-4"
              alt="1"
              srcset=""
            >
            <p><strong>Déterminer les risques liés à une activité. </strong></p>
            <p>Qu'est-ce qui peut mal tourner?</p>
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            <img
              src="@/assets/img/_content/03-2.svg"
              class="img-fluid w-50 mb-4"
              alt="2"
              srcset=""
            >
            <p><strong>Analyser ces risques. </strong></p>
            <p>Quelle est la probabilité qu'ils surviennent? Quelle est la gravité des conséquences?</p>
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            <img
              src="@/assets/img/_content/03-3.svg"
              class="img-fluid w-50 mb-4"
              alt="3"
              srcset=""
            >
            <p><strong>Prévoir la façon de gérer chaque risque. </strong></p>
            <p>Qu’allez-vous faire?</p>
          </div>
        </div>
        <p>Le fait de chavirer peut avoir des conséquences mortelles. Suivre des cours de natation, porter un vêtement de flottaison individuel (VFI), suivre des cours d'aviron et s'exercer permettent de diminuer les risques et les conséquences indésirables. </p>
        <p>Si les conséquences du risque sont graves et que la probabilité qu’il se produise est grande, il est recommandé de ne tout simplement pas entreprendre l'activité.  </p>
        <p>Voilà pourquoi il ne faut pas sortir sur l'eau au beau milieu d'une tempête ou lorsqu'une tempête risque de s'abattre d'un instant à l'autre. Voilà aussi pourquoi les rameurs débutants ne peuvent sortir sur l'eau sans supervision et qu’il n’y a pas de régates sans juges-arbitres et embarcations de sécurité.</p>
        <p class="text-key-take">Vous êtes responsable de votre propre sécurité et de ne pas mettre les autres en danger.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="4"
          link="sb-04"
        >
          La sécurité d'abord
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-04 -->
    <div
      id="sb-04"
      class="bg-img bg-img--01"
      v-if="$store.state.currentLocation >= 4"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Atténuer les risques liés à l'aviron, c'est votre responsabilité</h2>
        <p>L'aviron comporte de nombreux risques.  </p>
        <p>RCA, les associations provinciales d'aviron et les clubs d'aviron prennent des mesures pour diminuer les risques liés à l'aviron. Les clubs sont fortement encouragés à revoir régulièrement les protocoles de sécurité avec les membres.</p>
        <p>Le gouvernement fédéral a élaboré le <em>Guide de sécurité nautique</em> et le <em>Règlement sur les restrictions visant l'utilisation des bâtiments</em> et il a instauré l'obligation de détenir une carte de conducteur d'embarcation de plaisance (pour les bateaux à moteur seulement).</p>
        <p>RCA a mis en place des lignes directrices liées à la sécurité, une politique de sanction des événements, un manuel des régates et d'autres politiques et exigences pour diminuer les risques liés à notre sport.  </p>
        <p>Tout au long de ce cours, ces documents seront mentionnés fréquemment. Il est de votre responsabilité de les consulter avant d'entreprendre vos activités d'aviron.</p>
        <p></p>
        <button-sequenced
          class="btn-nav--red"
          :loc="5"
          link="sb-05"
        >
          Je consulterai ces documents
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-01 -->
    <div
      id="sb-05"
      v-if="$store.state.currentLocation >= 5"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Être prudent et prévenir les autres </h2>
        <p>Vous devez connaitre les règles, les réglementations, les lignes directrices et les protocoles qui sont en place puisque vous devrez les appliquer lorsque nécessaire.  </p>
        <p>Pour mieux vous préparer à réagir aux situations changeantes en aviron, vous devez avoir <span class="text-red">conscience de la situation</span>. Cela veut dire que vous devez comprendre où se situe votre embarcation par rapport aux autres. Cette conscience de la situation peut vous aider à prévenir les collisions et à éviter les interférences avec vos mouvements sécuritaires sur l'eau. </p>
        <p>Voici quelques conseils pour vous préparer à une expérience sécuritaire sur l'eau.</p>
        <div class="row">
          <div class="col-md-6 col-sm-4">
            <ul class="grid-list">
              <li>Planifiez votre parcours si vous comptez sortir sans entraîneur ou embarcation de sécurité.</li>
              <li>Munissez-vous d'un VFI, de feux de navigation et d’un équipement de sécurité. </li>
              <li>Vérifiez les prévisions météo dans votre région.</li>
            </ul>
          </div>
          <div class="col-md-6 col-sm-4">
            <ul class="grid-list grid-list--border-left">
              <li>Utilisez le <span class="text-red">journal de sortie et d'entrée</span> de votre <span class="text-red">club</span>, s'il y en a un.</li>
              <li>Avisez quelqu'un de votre sortie sur l'eau, de votre parcours et du moment prévu de votre retour. Avisez aussi cette personne lorsque vous êtes de retour. </li>
            </ul>
          </div>
        </div>
        <p>Si vous êtes témoin d’une situation sur l'eau qui pourrait être dangereuse pour vous ou quelqu'un d'autre, signalez-la au plus vite et surveillez-la jusqu'à ce que cette situation soit résolue.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="6"
          link="sb-06"
        >
          Sages conseils
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-06 -->
    <div
      id="sb-06"
      v-if="$store.state.currentLocation >= 6"
    >
      <content-block class="quiz-bg">
        <h2 class="content-block__header content-block__header">Un orage à l'horizon</h2>
        <quiz-radio
          :questions="q01"
          @quiz-complete="
                $store.dispatch('showNext', { n: 7, el: '#menu' })
              "
        ></quiz-radio>
        <!-- <button-sequenced class="btn-nav--red" :loc="0" link="menu">
          Let’s go
        </button-sequenced> -->
      </content-block>
    </div>
    <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 7"
    >
      <h3>Menu principal</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
  },
  data() {
    return {
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
          <p class="text-key-take">Vous êtes le rameur de proue d'un quad et votre équipage a commencé à s'entraîner à 16 h. À 16 h 30, le temps se met à changer rapidement. Les vents donnent lieu à des vagues et de l'eau entre dans le bateau. Vous êtes à 5 km du club.</p>
        <p class="text-key-take">Quelle est l'option la plus sûre?</p>
          `,
          questionArray: [
            'Retourner au club immédiatement.',
            'Appeler le club pour demander à une embarcation de sécurité de venir vous remorquer.',
            'Vous rendre au refuge le plus sûr et appeler le club une fois en sécurité.',
            'Quitter l\'embarcation si elle est remplie d\'eau et nager jusqu\'à la berge la plus près.'
          ],
          corrective: 'Vous rendre au refuge le plus sûr et appeler le club une fois en sécurité.',
          model: [],
          answer: '',
          answerText: `
            <p>Si vous ramez 5 km pendant une tempête, il y aura peut-être trop d'eau dans l'embarcation. Il vaut mieux se réfugier en lieu sûr. Il est de votre responsabilité de déterminer les points de refuge avant de sortir sur l'eau. Ne jamais abandonner une embarcation; même si elle est remplie d'eau ou qu'elle a chaviré, il s'agit d'un dispositif de flottaison plutôt utile.</p>
          `,
        },
      ],
    };
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  background-image: url("../assets/img/_chapter-headers/mbl/2-risk-assessment-mbl-fr.jpg");
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    background-image: url("../assets/img/_chapter-headers/dsk/2-risk-assessment-dsk-fr.jpg");
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
